import { render, staticRenderFns } from "./simulador.vue?vue&type=template&id=48963572&scoped=true"
import script from "./simulador.vue?vue&type=script&lang=js"
export * from "./simulador.vue?vue&type=script&lang=js"
import style0 from "./simulador.vue?vue&type=style&index=0&id=48963572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48963572",
  null
  
)

export default component.exports